// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSNewsPanel/index.less
// module id = 857
// module chunks = 42